/* DESKIZO product page blocks
   - Promo line: shrinks its font until the single line fits (as on Pawira).
   - Countdown: counts down to the block's real end date and hides itself when it ends.
   - Stock alert / stock line: follow the selected variant's tracked stock.
   - Ships-by date: today + N days (optionally skipping weekends), in the visitor's time zone.
   - Videos: tap to play/pause, progress bar; review slider with dots. */
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  /* promo line fit */
  const fit = (box) => {
    box.style.fontSize = '';
    let size = parseFloat(getComputedStyle(box).fontSize) || 17;
    box.style.fontSize = `${size}px`;
    while (box.scrollWidth > box.clientWidth && size > 8) {
      size -= 0.5;
      box.style.fontSize = `${size}px`;
    }
    // the rating line below uses the same text size as this line
    const text = box.querySelector('.dz-urg__text');
    if (text) document.documentElement.style.setProperty('--dz-urg-size', getComputedStyle(text).fontSize);
  };
  document.querySelectorAll('[data-dz-fit]').forEach((box) => {
    fit(box);
    if (window.ResizeObserver) new ResizeObserver(() => fit(box)).observe(box);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => fit(box));
  });

  /* countdown */
  document.querySelectorAll('[data-dz-countdown]').forEach((el) => {
    const end = Number(el.dataset.dzCountdown) * 1000;
    const units = Object.fromEntries([...el.querySelectorAll('[data-unit]')].map((u) => [u.dataset.unit, u]));
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const s = Math.floor(left / 1000);
      units.d.textContent = pad(Math.floor(s / 86400));
      units.h.textContent = pad(Math.floor((s % 86400) / 3600));
      units.m.textContent = pad(Math.floor((s % 3600) / 60));
      units.s.textContent = pad(s % 60);
      if (left === 0) {
        clearInterval(timer);
        if (!window.Shopify || !window.Shopify.designMode) el.hidden = true;
      }
    };
    const timer = setInterval(tick, 1000);
    tick();
  });

  /* ships-by date */
  document.querySelectorAll('[data-dz-ship-date]').forEach((el) => {
    const date = new Date();
    let days = Number(el.dataset.dzShipDate) || 0;
    const skip = el.dataset.skipWeekends === 'true';
    while (days > 0) {
      date.setDate(date.getDate() + 1);
      if (!skip || (date.getDay() !== 0 && date.getDay() !== 6)) days -= 1;
    }
    el.textContent = date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });

  /* stock lines follow the selected variant */
  const stockEls = [...document.querySelectorAll('[data-dz-stock]')];
  if (stockEls.length) {
    const update = (variantId) => {
      stockEls.forEach((el) => {
        let stock;
        try { stock = JSON.parse(el.dataset.dzStock); } catch (e) { return; }
        const qty = stock[variantId];
        const limit = Number(el.dataset.threshold) || 0;
        const low = typeof qty === 'number' && qty > 0 && qty <= limit;
        const label = el.querySelector('[data-dz-stock-label]');
        if (label) {
          el.classList.toggle('is-low', low);
          label.textContent = low ? el.dataset.low : el.dataset.ok;
        } else if (!(window.Shopify && window.Shopify.designMode)) {
          el.hidden = !low;
        }
      });
    };
    const currentId = () => {
      const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return input && input.value;
    };
    let last = currentId();
    const check = () => {
      const id = currentId() || new URLSearchParams(location.search).get('variant');
      if (id && id !== last) { last = id; update(id); }
    };
    document.addEventListener('change', () => setTimeout(check, 50));
    document.addEventListener('click', () => setTimeout(check, 120));
  }

  /* videos */
  document.querySelectorAll('.dz-vr').forEach((root) => {
    const track = root.querySelector('[data-dz-vr-track]');
    const thumb = root.querySelector('[data-dz-vr-thumb]');
    if (track) {
      track.querySelectorAll('.dz-vr__slide').forEach((slide) => {
        const video = slide.querySelector('video');
        const toggle = () => {
          if (video.paused) {
            track.querySelectorAll('video').forEach((v) => { if (v !== video) v.pause(); });
            video.muted = false;
            video.play().catch(() => { video.muted = true; video.play(); });
          } else {
            video.pause();
          }
        };
        slide.addEventListener('click', toggle);
        video.addEventListener('play', () => slide.classList.add('is-playing'));
        video.addEventListener('pause', () => slide.classList.remove('is-playing'));
      });
      const bar = () => {
        if (!thumb) return;
        const max = track.scrollWidth - track.clientWidth;
        const visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        thumb.style.width = `${Math.min(100, visible * 100)}%`;
        const move = max > 0 ? (track.scrollLeft / max) * (100 / visible - 100) : 0;
        thumb.style.transform = `translateX(${move}%)`;
        root.querySelector('.dz-vr__bar').hidden = visible >= 0.999;
      };
      track.addEventListener('scroll', bar, { passive: true });
      window.addEventListener('resize', bar);
      bar();
    }

    const reviews = root.querySelector('[data-dz-vr-reviews] .dz-vr__rtrack');
    const dots = root.querySelector('[data-dz-vr-dots]');
    if (reviews && dots) {
      const items = [...reviews.children];
      if (items.length > 1) {
        items.forEach((item, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Show review ${i + 1}`);
          dot.addEventListener('click', () => reviews.scrollTo({ left: item.offsetLeft - reviews.offsetLeft, behavior: 'smooth' }));
          dots.appendChild(dot);
        });
        const mark = () => {
          const i = Math.round(reviews.scrollLeft / reviews.clientWidth);
          [...dots.children].forEach((d, j) => d.setAttribute('aria-current', String(i === j)));
        };
        reviews.addEventListener('scroll', mark, { passive: true });
        mark();
      }
    }
  });
})();
